import { createContext, useContext, useState, type ReactNode } from 'react';
import { getApiKey, setApiKey } from '../api/client.js';

interface ApiKeyContextValue {
  apiKey: string | null;
  set: (k: string | null) => void;
}

const ApiKeyContext = createContext<ApiKeyContextValue | undefined>(undefined);

export function ApiKeyProvider({ children }: { children: ReactNode }) {
  const [key, setKey] = useState<string | null>(getApiKey());

  function set(next: string | null) {
    setApiKey(next);
    setKey(next);
  }

  return <ApiKeyContext.Provider value={{ apiKey: key, set }}>{children}</ApiKeyContext.Provider>;
}

export function useApiKey() {
  const ctx = useContext(ApiKeyContext);
  if (!ctx) throw new Error('useApiKey must be used inside <ApiKeyProvider>');
  return ctx;
}
